import React from 'react';
import styles from './styles.module.sass';
import cx from 'classnames';
import { locations } from '../../constants';
import { slugify } from '../../helpers';
import Page from '../../layouts/Page';
import Button from '../../components/Button';
import Logo from '../../assets/images/logo.svg?react';

const PUBLIC_URL = process.env.PUBLIC_URL || '';

const Home: React.FC = () => (
  <Page className={styles.home}>
    <Logo className={styles.logo} />
    {locations.map(location => {
      const slug = slugify(location);
      const isComing = location === 'Yogya';
      const classList = cx(styles.loc, styles[`loc__${slug}`]);

      return isComing ? (
        <Button
          key={slug}
          buttonVariant="frameless"
          comingSoon
          className={classList}
        >
          <span>{location}</span>
        </Button>
      ) : (
        <Button
          key={slug}
          to={`${PUBLIC_URL}/${slug}`}
          buttonVariant="frameless"
          className={classList}
        >
          {location}
        </Button>
      );
    })}
  </Page>
);

export default Home;